/**
 * API Configuration
 * Environment-based configuration for backend connectivity
 */

import { configService } from '../services/configService';

export const API_CONFIG = {
  BASE_URL: configService.getBackendUrl(),
  ENVIRONMENT: process.env.NODE_ENV,
};
